module.exports = __webpack_public_path__ + "images/baby.c71b2ed7b82b22274fdc2032e59afaef.svg";